import styled from '@emotion/styled'
import { ThemeFontSize } from '@open-tender/types'
import { ColorName } from 'utils/types'

const Heading = styled.span<{
  size?: ThemeFontSize
  color?: ColorName | string
}>`
  ${({ theme, size, color }) => `
    font-family: ${theme.fonts.headings.family};
    font-weight: ${theme.fonts.headings.weight};
    font-style: ${theme.fonts.headings.fontStyle};
    letter-spacing: ${theme.fonts.headings.letterSpacing};
    line-height: ${theme.fonts.headings.lineHeight};
    text-transform: ${theme.fonts.headings.textTransform};
    -webkit-font-smoothing: ${theme.fonts.headings.fontSmoothing};
    color: ${color ? theme.colors[color] : theme.fonts.headings.color};
    ${size ? `font-size: ${theme.fonts.sizes[size]};` : ''}
  `}
`

export default Heading
